import React, { createContext, useContext, useState } from "react";

const EmpresaContext = createContext(null);

export function EmpresaProvider({ children }) {
  const [empresa, setEmpresaState] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("sinin_empresa") || "null");
    } catch {
      return null;
    }
  });

  const setEmpresa = (data) => {
    if (data) {
      localStorage.setItem("sinin_empresa", JSON.stringify(data));
    } else {
      localStorage.removeItem("sinin_empresa");
    }
    setEmpresaState(data);
  };

  const logout = () => {
    localStorage.removeItem("sinin_empresa");
    localStorage.removeItem("sinin_token");
    setEmpresaState(null);
  };

  // Colores con fallback
  const colores = {
    primario:  empresa?.colorTicket  || "#dfa66b",
    fondo:     empresa?.colorFondo   || "#1a1a1a",
    fuente:    empresa?.colorFuente  || "#ffffff",
    dark:      empresa?.colorDark    || "#333333",
    light:     empresa?.colorLight   || "#555555",
  };

  return (
    <EmpresaContext.Provider value={{ empresa, setEmpresa, logout, colores }}>
      {children}
    </EmpresaContext.Provider>
  );
}

export function useEmpresa() {
  return useContext(EmpresaContext);
}
